(function () {
  'use strict';

  /**
   * XModal
   */
  class XModal extends HTMLElement {
    constructor() {
      super();

      this.cancelButton = this.querySelector('.button--cancel');
      this.confirmButton = this.querySelector('.button--confirm');
    }
    connectedCallback() {
      this.cancelButton?.addEventListener('click', this._onCancel.bind(this));
      this.confirmButton?.addEventListener('click', this._onConfirm.bind(this));
    }
    _open() {
      this.classList.add('active');
    }
    _close() {
      this.classList.remove('active');
    }
    _onConfirm() {
      this._close();
    }
    _onCancel(e) {
      e.preventDefault();

      this._close();
    }
  }
  if (!window.customElements.get('x-modal')) {
    window.customElements.define('x-modal', XModal);
  }

  class CartDrawerDiscount extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      this.onApplyCouponListener = this._onApplyCoupon.bind(this);
      this.onRemoveCouponListener = this._onRemoveCoupon.bind(this);
      this.error = '';
    }
    set error(value = '') {
      try {
        const errorHtml = this.querySelector('#discount-error');

        errorHtml.innerHTML = value;
      } catch (err) {
        console.error(err);
      }
    }
    connectedCallback() {
      this.button.addEventListener('click', this.onApplyCouponListener);
      document.querySelector('#remove-coupon')?.addEventListener('click', this.onRemoveCouponListener);
    }
    disconnectedCallback() {
      this.button.removeEventListener('click', this.onApplyCouponListener);
      document.querySelector('#remove-coupon')?.removeEventListener('click', this.onRemoveCouponListener);
    }
    async _onApplyCoupon() {
      this._onApply(this.querySelector('input').value);
    }
    async _onRemoveCoupon() {
      this._onApply('null');
    }
    async _onApply(couponCode = '') {
      try {
        if (couponCode == '') {
          return null;
        }

        await fetch('/checkout?discount=' + couponCode).then((r) => r.text());

        const { total_discount } = await fetch('/cart.json').then((r) => r.json());

        if (total_discount == 0) {
          this.error = 'Use um cupom válido';
        }

        document.dispatchEvent(new CustomEvent('cart:refresh'));
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('cart-drawer-discount')) {
    window.customElements.define('cart-drawer-discount', CartDrawerDiscount);
  }

  class ATCModal extends HTMLElement {
    constructor() {
      super();

      this.button = document.querySelector('.buy-buttons button[type="submit"]');
    }
    connectedCallback() {
      window.addEventListener('scroll', this._show.bind(this));

      this._show.call(this);
    }
    _show() {
      try {
        const footerInfo = document.querySelector('.shopify-section-group-footer-group');

        if (footerInfo && this.button) {
          const footerInfoRect = footerInfo.getBoundingClientRect();
          const buttonInfoRect = this.button.getBoundingClientRect();

          if (buttonInfoRect.top + buttonInfoRect.height <= 0 && footerInfoRect.top > window.innerHeight) {
            this.classList.add('show');
          } else {
            this.classList.remove('show');
          }
        }
      } catch (err) {
        console.error(err);
      }
    }
  }

  if (!window.customElements.get('atc-modal')) {
    window.customElements.define('atc-modal', ATCModal);
  }

  /**
   * Quizz Popup
   */
  class QuizzPopup extends HTMLElement {
    constructor() {
      super();

      this.questionContainer = this.querySelector('.quizz-popup__questions-list');
      this.questionsList = this.querySelectorAll('.quizz-popup__question');
      this.answersList = [];
      this.answersInputs = this.querySelectorAll('input[type="radio"]');
      this.button = this.querySelector('button.quizz-popup__button');
      this.closeButton = this.querySelector('.quizz-popup__button-close');
    }
    connectedCallback() {
      this.answersInputs.forEach((answer) => answer.addEventListener('change', this._onChange.bind(this)));
      this.button.addEventListener('click', this._onSubmit.bind(this));
      this.closeButton.addEventListener('click', this._closeModal.bind(this));

      window.addEventListener('keyup', (e) => {
        if (e.key === 'Escape') {
          this._closeModal();
        }
      });

      document.addEventListener('click', (e) => {
        if (e.target.classList.contains('quizz-popup')) {
          this._closeModal();
        }
      });

      if (this.get() !== 'true') {
        this.classList.remove('hide');
      }
    }
    _closeModal() {
      this.save();
      this.remove();
    }
    get() {
      return window.sessionStorage.getItem('_qmh');
    }
    save() {
      window.sessionStorage.setItem('_qmh', 'true');
    }
    _onBackLinkClick() {
      this.querySelector('[href="#close"]').addEventListener('click', (e) => {
        e.preventDefault();

        this._closeModal();
      });
    }
    _onChange() {
      const answerCount = this.questionsList.length;
      const answeredQuestion = Array.from(this.answersInputs).filter((i) => i.checked === true).length;

      this.button.disabled = !(answerCount === answeredQuestion);

      this._saveAnswer();
    }
    _saveAnswer() {
      this.answersList = Array.from(this.answersInputs)
        .filter((i) => i.checked === true)
        .map((i) => i.value);
    }
    _onSubmit(e) {
      this.answersInputs.forEach((input) => (input.disabled = true));

      this.button.disabled = true;
      this.button.innerHTML = 'Processado...';

      setTimeout(() => {
        this._showResult();
      }, 1000);
    }
    _showResult() {
      const isEquals = (arr1, arr2) => JSON.stringify(arr1) === JSON.stringify(arr2);
      let content = '';

      /* Logic for display the result */
      if (
        isEquals(this.answersList, ['yes', 'yes', 'yes']) ||
        isEquals(this.answersList, ['no', 'yes', 'yes']) ||
        isEquals(this.answersList, ['yes', 'yes', 'no']) ||
        isEquals(this.answersList, ['yes', 'no', 'yes'])
      ) {
        content = `
          <div class="quiz-popup__result">
            <div>
              <h3 class="h5">Nutrição</h3>
              <p>Seu cabelo precisa de nutrição! A reposição de vitaminas e nutrientes é essencial para garantir a saúde dos fios</p>
            </div>
            
            <a href="/products/kit-linha-nutricao-completa" title="oferta" class="quizz-popup__button color--nutrition">Eu quero</a>
            
            <div class="text-center">
              <a href="#close" class="link">Fechar</a>
            </div>
          </div>
        `;
      } else {
        content = `
          <div class="quiz-popup__result">
            <div>
              <h3 class="h5">Kit Completo</h3>
              <p>Que bom que seu cabelo está bonito. Que tal manter o cronograma capilar para continuar saudável?</p>
            </div>
            
            <a href="/products/kit-shampoo-e-condicionador-cronograma-nutricao" title="oferta" class="quizz-popup__button">Eu quero</a>
            
            <div class="text-center">
              <a href="#close" class="link">Fechar</a>
            </div>
          </div>
        `;
      }

      this.button.remove();
      this.questionContainer.innerHTML = content;

      this._onBackLinkClick();
    }
  }
  if (!window.customElements.get('quizz-popup')) {
    window.customElements.define('quizz-popup', QuizzPopup);
  }
  //translateX(calc(-200% - calc(2 * var(--spacing-7))))
  //translateX(calc(calc(var(--current) * -100%) - calc(var(--current) * var(--spacing-7))))

  class ContactFloat extends HTMLElement {
    constructor() {
      super();

      this.icon = this.querySelector('.contact-float__icon');
    }
    connectedCallback() {
      this.icon.addEventListener('click', this.toggleBox.bind(this));
    }
    toggleBox() {
      this.classList.toggle('open');
    }
  }
  if (!window.customElements.get('contact-float')) {
    window.customElements.define('contact-float', ContactFloat);
  }

  /** Line item buttom */
  class LineItemButton extends HTMLElement {
    constructor() {
      super();

      this.button = this.querySelector('button');
      this.onClickListener = this._onClickListener.bind(this);
    }
    connectedCallback() {
      if (this.button) {
        this.button.addEventListener('click', this.onClickListener);
      }
    }
    _onClickListener(e) {
      let quantity;

      e.preventDefault();

      const lineItem = this.closest('line-item-quantity');
      const quantityInput = lineItem.querySelector('.quantity-input');
      const action = this.dataset.action;

      lineItem.querySelectorAll('button,input').forEach((el) => (el.disabled = true));

      switch (action) {
        case 'minus':
          if (quantityInput.value == 1) {
            return;
          }

          quantity = parseInt(quantityInput.value);
          quantity--;
          quantity = Math.max(1, quantity);
          quantityInput.value = quantity;

          quantityInput.dispatchEvent(
            new Event('change', {
              bubbles: true,
            }),
          );
          break;

        case 'plus':
          quantity = parseInt(quantityInput.value);
          quantity++;
          quantityInput.value = quantity;
          quantityInput.dispatchEvent(
            new Event('change', {
              bubbles: true,
            }),
          );
          break;
      }
    }
  }

  if (!window.customElements.get('line-item-button')) {
    window.customElements.define('line-item-button', LineItemButton);
  }

  /* X-Timer */
  class XTimer extends HTMLElement {
    constructor() {
      super();

      this.end = this.getAttribute('end');
      this.dateFormat = this.getAttribute('date-format') || null;
      this.message = this.getAttribute('message');
      this.showDays = this.getAttribute('show-days') === 'true';
      this.parent = this.getAttribute('parent');
      this.separatorNominal = this.getAttribute('separator-nominal') === 'true';
      this.acumulateHours = this.getAttribute('acumulate-hours') === 'true';
    }
    connectedCallback() {
      this.run();
    }
    _parseDate(format = 'br') {
      const [date, time] = this.end.split(' ');

      switch (format) {
        case 'br':
          const [day, month, year] = date.split('/');
          const [hour, minute, second] = time.split(':');

          return `${year}-${month}-${day}T${hour}:${minute}:${second}`;
      }
    }
    run() {
      /**
       * Timer format: yyyy-mm-ddTHH:mm:ssZ
       * Example: 2026-02-10T00:00:00Z (standard of the date & time for shopify field type)
       */
      const endAt = this.dateFormat ? this._parseDate(this.dateFormat) : this.end;
      const endTimestamp = new Date(endAt).getTime();

      const intervalTime = setInterval(() => {
        const now = new Date().getTime();
        const distance = endTimestamp - now;

        if (distance < 0) {
          if (this.parent) {
            const parent = this.closest(this.parent);

            parent ? parent.remove() : this.remove();
          } else {
            this.remove();
          }
          return clearInterval(intervalTime);
        }

        const _days = Math.floor(distance / (1000 * 60 * 60 * 24));
        const _hours =
          Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)) +
          (this.acumulateHours === true ? _days * 24 : 0);
        const _minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const _seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (typeof callback === 'function') {
          return callback(_days, _hours, _minutes, _seconds);
        }

        let response = '';

        const formatter = (value) => {
          const interedValue = parseInt(value);
          const quocient = parseInt(interedValue / 10);
          const modRest = parseInt(interedValue % 10);

          return `<span class="x-timer__value-part">${quocient}</span><span class="x-timer__value-part">${modRest}</span>`;
        };

        if (this.showDays === true && _days > 0) {
          response +=
            `<span class="x-timer__value" data-value="Dias">${formatter(('00' + _days).slice(-2))}</span>` +
            '<span class="x-timer__separator">d</span> ';
        }
        response +=
          `<span class="x-timer__value" data-value="Horas">${formatter(('00' + _hours).slice(-2))}</span>` +
          (this.separatorNominal ? '<span class="x-timer__separator">h</span> ' : ':');
        response +=
          `<span class="x-timer__value" data-value="Minutos">${formatter(('00' + _minutes).slice(-2))}</span>` +
          (this.separatorNominal ? '<span class="x-timer__separator">m</span> ' : ':');
        response +=
          `<span class="x-timer__value" data-value="Segundos">${formatter(('00' + _seconds).slice(-2))}</span>` +
          (this.separatorNominal ? '<span class="x-timer__separator">s</span>' : '');

        this.innerHTML = `${this.message || ''} ${response}`.trim();
      }, 1000);
    }
  }
  if (!window.customElements.get('x-timer')) {
    window.customElements.define('x-timer', XTimer);
  }

  class DeliveryTime extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.run();
    }
    async run() {
      try {
        const { title, variants } = await fetch(window.location.origin + `${location.pathname}.js`, {
          headers: {
            'Content-Type': 'application/json',
          },
        }).then((r) => r.json());

        const data = {
          service: 'shopify',
          include_time_to_delivery: 1,
          rate: {
            origin: { country: 'BR', postal_code: '04358-090' },
            destination: { country: 'BR', postal_code: '04358-090' },
            items: [
              { name: title, sku: variants[0].sku, price: variants[0].price, quantity: 1, grams: variants[0].weight },
            ],
            currency: 'BRL',
          },
        };

        const { rates } = await fetch(
          'https://app.expedido.com.br/api/v1/shipping-rates/10f7fe2a-8b25-41eb-9ee8-94573b59d91c',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify(data),
          },
        ).then((r) => r.json());

        const response = `
          <div class="text-center text-sm delivery-time__text">
            ${rates.map((rate) => {
              const minDate = new Date(rate.min_delivery_date);
              const maxDate = new Date(rate.max_delivery_date);

              const minDateHtml = `${('0' + minDate.getDate()).slice(-2)}/${('0' + (minDate.getMonth() + 1)).slice(-2)}/${minDate.getFullYear()}`;
              const maxDateHtml = `${('0' + maxDate.getDate()).slice(-2)}/${('0' + (maxDate.getMonth() + 1)).slice(-2)}/${maxDate.getFullYear()}`;

              return `
                ${minDateHtml === maxDateHtml ? `Entrega prevista para <strong>${maxDateHtml}</strong>` : `Entrega prevista entre <strong>${minDateHtml}</strong> e <strong>${maxDateHtml}</strong>`}
              `;
            })}
          </div>
        `;

        this.innerHTML = response;
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('delivery-time')) {
    window.customElements.define('delivery-time', DeliveryTime);
  }

  /* Number Counter */
  class NumberCounter extends HTMLElement {
    constructor() {
      super();

      this.start = this.getAttribute('start');
      this.end = this.getAttribute('end');
      this.duration = this.getAttribute('duration');
    }
    connectedCallback() {
      this.animateValue();
    }
    animateValue() {
      let startTimestamp = null;

      const step = (timestamp) => {
        if (!startTimestamp) {
          startTimestamp = timestamp;
        }

        const progress = Math.min((timestamp - startTimestamp) / parseInt(this.duration), 1);
        const number =
          `${Math.floor(progress * (parseInt(this.end) - parseInt(this.start)) + parseInt(this.start))}`.trim();

        this.innerHTML = new Intl.NumberFormat('pt-BR').format(number);

        if (progress < 1) {
          window.requestAnimationFrame(step);
        }
      };

      window.requestAnimationFrame(step);
    }
  }
  if (!window.customElements.get('number-counter')) {
    window.customElements.define('number-counter', NumberCounter);
  }

  class XAnchor extends HTMLElement {
    #href;

    constructor() {
      super();

      this.#href = this.getAttribute('to');
    }
    connectedCallback() {
      this.addEventListener('click', this.redirect.bind(this));
    }
    redirect(e) {
      e.preventDefault();

      try {
        const destin = document.getElementById(this.#href);

        if (destin) {
          const coord = destin.getBoundingClientRect();

          window.scrollTo(0, window.scrollY + coord.top);
        }
      } catch (err) {
        console.error(err);
      }
    }
  }
  if (!window.customElements.get('x-anchor')) {
    window.customElements.define('x-anchor', XAnchor);
  }

  /* XBuynowButton */
  class XBuynowButton extends HTMLElement {
    #variant;
    #quantity;

    constructor() {
      super();

      this.#variant = this.getAttribute('variant');
      this.#quantity = this.getAttribute('quantity') || 1;
    }
    connectedCallback() {
      this.addEventListener('click', this._click.bind(this));
    }
    _click(e) {
      e.preventDefault();

      if (this.#variant === undefined || this.#variant === null) {
        return;
      }

      window.location.pathname = `/cart/${this.#variant}:${this.#quantity || 1}`;
    }
  }
  if (!window.customElements.get('x-buynow-button')) {
    window.customElements.define('x-buynow-button', XBuynowButton);
  }
})();
